module.exports = __webpack_public_path__ + "videos/animation-video-nikko.e86d295.mp4";